<template>
	<!-- Main Container -->
	<div>
		<div class="main-container">
			<!-- Graph Management Page -->
			<div v-show="currentPage === 'graph-management'">
				<section class="hero-section">
					<h1 class="hero-title">图谱管理</h1>
					<p class="hero-subtitle">管理已生成的知识图谱，设置主理人和权限管理</p>
				</section>

				<!-- Graph Statistics -->
				<!-- <div class="stats-grid">
					<div v-for="stat in graphStats" :key="stat.label" class="stat-card">
						<div class="stat-icon" :style="{ background: stat.color }">
							{{ stat.icon }}
						</div>
						<div class="stat-number">{{ stat.value }}</div>
						<div class="stat-label">{{ stat.label }}</div>
					</div>
				</div> -->

				<!-- Graph List -->
				<div class="management-section">
					<div class="section-header">
						<h2 class="section-title">知识图谱列表</h2>
						<div class="section-actions">
							<button class="btn btn-primary" @click="createNewGraph">新建图谱</button>
						</div>
					</div>

					<div class="graph-list">
						<div v-for="(graph,index) in knowledgeGraphs" :key="graph.id" class="graph-item">
							<div class="graph-info">
								<div class="graph-icon">
									{{ graph.gh_name_zh[0] }}
								</div>
								<div class="graph-details">
									<h3 class="graph-name">{{ graph.gh_name_zh }}</h3>
									<p class="graph-desc">{{ graph.description }}</p>
									<div class="graph-meta">
										<span>机构：{{ graph.institution }}</span>
										<span>标签：{{ graph.tags }}</span>
										<!-- <span>更新：{{ graph.lastUpdated }}</span> -->
									</div>
								</div>
							</div>
							<div class="graph-actions">
								<button class="btn btn-secondary" @click="viewDocuments(graph)">
									查看文档
								</button>
								<button class="btn btn-primary" @click="showManagerModal(graph)">
									主理人管理
								</button>
								<button class="btn btn-secondary" @click="editGraph(graph)">
									编辑图谱
								</button>
								<button class="btn btn-danger" @click="delGraph(graph.gh_code,index)">
									删除图谱
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Manager Modal -->
		<div :class="['modal-overlay', { show: showManModal }]" @click="closeManagerModal">
			<div class="modal" @click.stop>
				<div class="modal-header">
					<h2 class="modal-title">{{ materialForm.gh_name_zh }} - 主理人管理</h2>
					<button class="modal-close" @click="closeManagerModal">×</button>
				</div>
				<div class="modal-body">
					<div class="manager-assignment">
						<h3>当前主理人</h3>
						<div class="current-managers">
							<div v-for="(manager,index) in currentManagers" :key="index" class="current-manager">
								<div class="manager-avatar" :style="{ background: getManagerAvatarColor(manager) }">
									{{ getManagerAvatar(manager) }}
								</div>
								<div class="manager-info">
									<div class="manager-name">{{ getManagerDisplayName(manager) }}</div>
									<!-- <div class="manager-nodes">{{materialForm.gh_name_zh }}</div> -->
								</div>
								<button class="btn btn-danger btn-sm" @click="removeManager(index, manager)">
									删除
								</button>
							</div>
						</div>
						<div class="authorsVal">
							<div class="name">新增主理人:</div><el-input v-model="authorsVal" placeholder="请输入主理人姓名"
								style="flex: 1;" ></el-input>
							<el-button type="primary" @click="saveNewManager" class="save-btn">保存</el-button>
							<el-button type="text" @click="candidates" class="candidates">展开</el-button>
						</div>



						<h3 v-if="candidatesShow">分配新主理人</h3>
						<div class="manager-candidates" v-if="candidatesShow">
							<div v-for="candidate in managerCandidates" :key="candidate.id" class="candidate-item"
								@click="toggleCandidate(candidate.id)">
								<input type="checkbox" :id="`candidate-${candidate.id}`" v-model="selectedCandidates"
									:value="candidate.id" class="candidate-checkbox">
								<div class="candidate-info">
									<div class="candidate-avatar" :style="{ background: candidate.avatarColor }">
										{{ candidate.avatar }}
									</div>
									<div class="candidate-details">
										<div class="candidate-name">{{ candidate.name }}</div>
										<!-- <div class="candidate-role">{{ candidate.role || '主理人' }}</div> -->
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button class="btn btn-secondary" @click="closeManagerModal">取消</button>
					<button class="btn btn-primary" @click="saveManagerAssignment">保存设置</button>
				</div>
			</div>
		</div>
		<!-- Upload Modal -->
		<div class="modal-overlay" :class="{ show: showModal }" @click="closeModal">
			<div class="modal" @click.stop>
				<div class="modal-header">
					<h2 class="modal-title">{{ isEditing ? '编辑图谱' : '新建图谱' }}</h2>
					<button class="modal-close" @click="closeModal">×</button>
				</div>
				<div class="modal-body">
					<form @submit.prevent="saveMaterial">
						<div class="form-group">
							<label class="form-label">图谱名称（中文）</label>
							<input type="text" class="form-input" v-model="materialForm.gh_name_zh"
								placeholder="请输入图谱名称（中文）" required>
						</div>
						<div class="form-group">
							<label class="form-label">图谱名称（英文）</label>
							<input type="text" class="form-input" v-model="materialForm.gh_name_en"
								placeholder="请输入图谱名称（英文）" required>
						</div>
						<div class="form-group">
							<label class="form-label">图谱代码</label>
							<input type="text" class="form-input" v-model="materialForm.gh_code" placeholder="请输入图谱代码"
								:disabled="isEditing?true:false" required>
						</div>
						<div class="form-group">
							<label class="form-label">图谱描述</label>
							<textarea class="form-textarea" v-model="materialForm.description"
								placeholder="请简要图谱描述"></textarea>
						</div>
						<div class="form-group">
							<label class="form-label">标签</label>
							<input type="text" class="form-input" v-model="materialForm.tags" placeholder="请输入标签，用逗号分割">
						</div>
						<div class="form-group">
							<label class="form-label">机构</label>
							<input type="text" class="form-input" v-model="materialForm.institution"
								placeholder="请输入机构">
						</div>
						<div class="form-group">
							<label class="form-label">作者</label>
							<input type="text" class="form-input" v-model="materialForm.authors" placeholder="请输入作者">
						</div>
						<div class="form-group">
							<label class="form-label">是否公开</label>
							<el-switch v-model="isOpenSwitch" active-text="公开" inactive-text="私有"
								@change="handleOpenChange">
							</el-switch>
						</div>

					</form>
				</div>
				<div class="modal-footer">
					<button class="btn btn-secondary" @click="closeModal">取消</button>
					<button class="btn btn-primary" @click="saveMaterial">保存</button>
				</div>
			</div>
		</div>

		<!-- 查看文档对话框 -->
		<el-dialog
			title="图谱文档列表"
			:visible.sync="docDialogVisible"
			width="800px"
			:close-on-click-modal="false"
		>
			<div class="document-list" v-if="documentList.length > 0">
				<div v-for="doc in documentList" :key="doc.file_id" class="document-item">
					<div class="doc-icon">{{ getDocIcon(doc.file_type) }}</div>
					<div class="doc-info">
						<div class="doc-name">{{ doc.original_file_name }}</div>
						<div class="doc-meta">
							<span>大小: {{ formatFileSize(doc.file_size) }}</span>
							<span>类型: {{ doc.file_type }}</span>
							<span>上传时间: {{ doc.upload_time }}</span>
						</div>
						<div v-if="doc.description" class="doc-description">{{ doc.description }}</div>
					</div>
					<div class="doc-actions">
						<el-button size="small" @click="downloadDocument(doc)">下载</el-button>
					</div>
				</div>
			</div>
			<div v-else class="empty-documents">
				<p>该图谱暂无上传的文档</p>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="docDialogVisible = false">关闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		name: 'GraphView',
		data() {
			return {
				currentPage: 'graph-management',
				showModal: false,
				isEditing: false,
				editingMaterial: null,
				materialForm: {
					gh_code: '',
					gh_name_zh: '',
					gh_name_en: '',
					description: '',
					tags: '',
					institution: '',
					authors: '',
					is_open: 'open'
				},
				knowledgeGraphs: [],
				isOpenSwitch: true, // 用于el-switch组件的布尔值
				showManModal: false,
				authorsVal: '',
				candidatesShow: false,
				selectedCandidates: [],
				graphStats: [{
						icon: '📊',
						value: '5',
						label: '已生成图谱',
						color: 'var(--primary)'
					},
					{
						icon: '👥',
						value: '24',
						label: '活跃主理人',
						color: 'var(--secondary)'
					},
					{
						icon: '⚡',
						value: '98.5%',
						label: '图谱完整度',
						color: 'var(--warning)'
					},
					{
						icon: '🔄',
						value: '156',
						label: '今日更新',
						color: 'var(--success)'
					}
				],
				currentManagers: [],
				docDialogVisible: false,
				documentList: [],
				currentGraphForDocs: null,
				managerCandidates: []
			}
		},
		computed: {

		},
		mounted() {
			this.grapData();
		},
		methods: {
			candidates() {
				this.candidatesShow = !this.candidatesShow
				if (this.candidatesShow) {
					this.loadManagerCandidates()
				}
			},
			// 加载主理人候选列表
			loadManagerCandidates() {
				this.HttpUtils.get('/api/manager/', {}).then(result => {
					if (result.data) {
						// 格式化数据，添加avatar和avatarColor
						this.managerCandidates = result.data.map(manager => {
							const name = manager.name || ''
							const firstChar = name.charAt(0) || '?'
							// 生成随机颜色
							const colors = ['var(--purple)', 'var(--orange)', 'var(--accent)', '#4CAF50', '#2196F3', '#FF9800']
							const colorIndex = manager.id % colors.length
							return {
								id: manager.id,
								name: manager.name,
								avatar: firstChar,
								avatarColor: colors[colorIndex],
								role: manager.role || '主理人',
								code: manager.code
							}
						})
					}
				}).catch(error => {
					console.error('加载主理人列表失败:', error)
					this.$message.error('加载主理人列表失败')
				})
			},
			// 保存新主理人
			saveNewManager() {
				if (!this.authorsVal || !this.authorsVal.trim()) {
					this.$message({
						message: '请输入主理人姓名',
						type: 'warning'
					})
					return
				}
				
				this.HttpUtils.post('/api/manager/', {
					name: this.authorsVal.trim()
				}).then(res => {
					if (res.data && res.data.message) {
						this.$message({
							message: '主理人保存成功！',
							type: 'success'
						})
						// 清空输入框
						this.authorsVal = ''
						// 刷新主理人列表
						this.loadManagerCandidates()
					} else {
						this.$message.error(res.data?.msg || '保存失败')
					}
				}).catch(error => {
					console.error('保存主理人失败:', error)
					this.$message.error(error.response?.data?.detail || '保存主理人失败')
				})
			},
			grapData() {
				this.HttpUtils.get('/api/gh-rel/', {}).then(result => {
					this.knowledgeGraphs = result.data
				})
			},
			//新建图谱
			createNewGraph() {
				this.resetForm()
				this.showModal = true;
			},
			editGraph(graph) {
				this.isEditing = true
				this.editingMaterial = graph
				this.materialForm = {
					gh_code: graph.gh_code,
					gh_name_zh: graph.gh_name_zh,
					gh_name_en: graph.gh_name_en,
					description: graph.description,
					tags: graph.tags,
					institution: graph.institution,
					authors: graph.authors,
					is_open: graph.is_open
				}
				// 根据is_open的值设置开关状态
				this.isOpenSwitch = graph.is_open === 'open';
				this.showModal = true
			},
			delGraph(gh_code, index) {
				this.$confirm('确定要删除这个图谱吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.HttpUtils.delete('/api/gh-rel/' + gh_code, {}).then(res => {
						console.log(res)
						if (res.data) {
							this.$message({
								message: res.data.message,
								type: 'success'
							});
							this.knowledgeGraphs.splice(index, 1);
						} else {
							this.$message.error(res.data.msg)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			closeModal() {
				this.showModal = false
				this.resetForm()
			},
			// 处理公开状态切换
			handleOpenChange(value) {
				this.materialForm.is_open = value ? 'open' : 'closed';
			},
			resetForm() {
				this.isEditing = false
				this.editingMaterial = null
				this.materialForm = {
					gh_code: '',
					gh_name_zh: '',
					gh_name_en: '',
					description: '',
					tags: '',
					institution: '',
					authors: '',
					is_open: 'open'
				}
				this.isOpenSwitch = true; // 重置开关状态
			},
			saveMaterial() {
				if (!this.materialForm.gh_name_zh || !this.materialForm.gh_name_en || !this.materialForm.gh_code || !this.materialForm.authors) {
					this.$message({
						message: '请填写完整的信息',
						type: 'warning'
					});
					return
				}
				if (this.isEditing) {
					const updatedMaterial = {
						...this.editingMaterial,
						gh_code: this.materialForm.gh_code,
						gh_name_zh: this.materialForm.gh_name_zh,
						gh_name_en: this.materialForm.gh_name_en,
						description: this.materialForm.description,
						tags: this.materialForm.tags,
						institution: this.materialForm.institution,
						authors: this.materialForm.authors,
						is_open: this.materialForm.is_open
					}
					console.log(updatedMaterial)
					this.HttpUtils.put('/api/gh-rel/graph_33', updatedMaterial).then(res => {
						console.log(res)
						if (res.data) {
							this.$message({
								message: res.data.message,
								type: 'success'
							});
							this.grapData();
							this.closeModal()
						} else {
							this.$message.error(res.data.msg)
						}
					})
				} else {
					this.HttpUtils.post('/api/gh-rel/', this.materialForm).then(res => {
						console.log(res)
						if (res.data) {
							this.$message({
								message: res.data.message,
								type: 'success'
							});
							this.grapData();
							this.closeModal()
						} else {
							this.$message.error(res.data.msg)
						}
					})
				}
			},

			showManagerModal(graph) {
				// 处理authors字段，可能是空字符串或null
				const authorsStr = graph.authors || ''
				this.currentManagers = authorsStr ? authorsStr.split(';').filter(m => m.trim()) : []
				this.materialForm.gh_code = graph.gh_code;
				this.materialForm.gh_name_zh = graph.gh_name_zh;
				this.authorsVal = '';
				this.selectedCandidates = [];
				this.candidatesShow = false;
				this.showManModal = true;
				// 加载主理人列表
				this.loadManagerCandidates();
			},
			closeManagerModal() {
				this.showManModal = false;
				this.selectedCandidates = [];
			},
			closeModal() {
				this.showModal = false;
			},
			toggleCandidate(candidateId) {
				const index = this.selectedCandidates.indexOf(candidateId);
				if (index > -1) {
					this.selectedCandidates.splice(index, 1);
				} else {
					this.selectedCandidates.push(candidateId);
				}
			},
			// 获取主理人显示名称
			getManagerDisplayName(manager) {
				if (!manager) return '';
				// 如果包含分号，提取名称部分（格式：code;name 或 name）
				if (manager.includes(';')) {
					const parts = manager.split(';');
					// 如果第二部分是名称，返回第二部分；否则返回整个字符串
					return parts.length > 1 ? parts[parts.length - 1] : manager;
				}
				return manager;
			},
			// 获取主理人头像字符
			getManagerAvatar(manager) {
				const name = this.getManagerDisplayName(manager);
				return name ? name.charAt(0) : '?';
			},
			// 获取主理人头像颜色
			getManagerAvatarColor(manager) {
				const name = this.getManagerDisplayName(manager);
				const colors = ['var(--purple)', 'var(--orange)', 'var(--accent)', '#4CAF50', '#2196F3', '#FF9800', '#9C27B0', '#F44336'];
				const colorIndex = (name ? name.charCodeAt(0) : 0) % colors.length;
				return colors[colorIndex];
			},
			// 删除当前主理人
			removeManager(index, manager) {
				this.$confirm('确认要删除该主理人吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// 从数组中移除
					this.currentManagers.splice(index, 1);
					
					// 立即更新数据库
					this.updateAuthorsInDatabase();
				}).catch(() => {
					// 用户取消删除
				});
			},
			// 更新数据库中的authors字段
			updateAuthorsInDatabase() {
				// 构建authors字符串
				const authorsStr = this.currentManagers
					.filter(m => m && m.trim())
					.map(m => m.trim())
					.join(';');
				
				// 更新到数据库
				this.HttpUtils.put('/api/gh-rel/' + this.materialForm.gh_code, {
					authors: authorsStr
				}).then(res => {
					if (res.data) {
						this.$message({
							message: '主理人已删除！',
							type: 'success'
						});
						// 刷新图谱列表
						this.grapData();
					} else {
						this.$message.error(res.data.msg || '删除失败');
						// 如果失败，重新加载当前主理人列表
						this.loadCurrentManagers();
					}
				}).catch(error => {
					console.error('删除主理人失败:', error);
					this.$message.error(error.response?.data?.detail || '删除主理人失败');
					// 如果失败，重新加载当前主理人列表
					this.loadCurrentManagers();
				});
			},
			// 重新加载当前主理人列表
			loadCurrentManagers() {
				// 从数据库重新获取图谱信息
				this.HttpUtils.get('/api/gh-rel/' + this.materialForm.gh_code, {}).then(result => {
					if (result.data && result.data.authors) {
						const authorsStr = result.data.authors || '';
						this.currentManagers = authorsStr ? authorsStr.split(';').filter(m => m.trim()) : [];
					}
				}).catch(error => {
					console.error('加载主理人列表失败:', error);
				});
			},
			saveManagerAssignment() {
				// 收集所有主理人，格式：code;name 或 name
				let authorList = [];
				
				// 保留当前主理人（已经存在的）
				this.currentManagers.forEach(manager => {
					if (manager && manager.trim()) {
						authorList.push(manager.trim());
					}
				});
				
				// 添加勾选的主理人
				if (this.selectedCandidates.length > 0) {
					this.selectedCandidates.forEach(candidateId => {
						const candidate = this.managerCandidates.find(c => c.id === candidateId);
						if (candidate) {
							// 检查是否已存在（避免重复）
							const exists = authorList.some(author => {
								// 如果author包含分号，提取name部分；否则直接比较
								const authorName = author.includes(';') ? author.split(';')[1] : author;
								return authorName === candidate.name;
							});
							
							if (!exists) {
								// 格式：code;name，如果没有code则只保存name
								if (candidate.code) {
									authorList.push(`${candidate.code};${candidate.name}`);
								} else {
									authorList.push(candidate.name);
								}
							}
						}
					});
				}
				
				// 如果有新输入的主理人姓名，也添加进去（临时添加，不会保存到manager表）
				if (this.authorsVal && this.authorsVal.trim()) {
					const newName = this.authorsVal.trim();
					// 检查是否已存在
					const exists = authorList.some(author => {
						const authorName = author.includes(';') ? author.split(';')[1] : author;
						return authorName === newName;
					});
					
					if (!exists) {
						authorList.push(newName);
					}
				}
				
				// 保存到gh_rel表的authors字段，格式：用分号分隔，如 '001;陈工;王明'
				const authorsStr = authorList.join(';');
				
				this.HttpUtils.put('/api/gh-rel/' + this.materialForm.gh_code, {
					authors: authorsStr
				}).then(res => {
					if (res.data) {
						this.closeManagerModal()
						this.$message({
							message: '主理人设置已保存！',
							type: 'success'
						});
						// 刷新图谱列表
						this.grapData();
					} else {
						this.$message.error(res.data.msg || '保存失败')
					}
				}).catch(error => {
					console.error('保存主理人设置失败:', error)
					this.$message.error(error.response?.data?.detail || '保存主理人设置失败')
				})
			},
			// 查看文档
			viewDocuments(graph) {
				this.currentGraphForDocs = graph;
				this.docDialogVisible = true;
				this.loadDocuments(graph.gh_code);
			},
			// 加载文档列表
			loadDocuments(gh_code) {
				this.HttpUtils.get('/api/file-info/by-graph/' + gh_code, {}).then(result => {
					if (result.data && result.data.data) {
						this.documentList = result.data.data;
					} else {
						this.documentList = [];
					}
				}).catch(error => {
					console.error('加载文档列表失败:', error);
					this.$message.error('加载文档列表失败');
					this.documentList = [];
				});
			},
			// 获取文档图标
			getDocIcon(fileType) {
				const iconMap = {
					'PDF': '📄',
					'WORD': '📝',
					'EXCEL': '📊',
					'POWERPOINT': '📽️',
					'TEXT': '📃',
					'IMAGE': '🖼️',
					'OTHER': '📎'
				};
				return iconMap[fileType] || '📎';
			},
			// 格式化文件大小
			formatFileSize(bytes) {
				if (bytes === 0) return '0 Bytes';
				const k = 1024;
				const sizes = ['Bytes', 'KB', 'MB', 'GB'];
				const i = Math.floor(Math.log(bytes) / Math.log(k));
				return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
			},
			// 下载文档
			downloadDocument(doc) {
				if (!doc.file_id) {
					this.$message.error('文件ID不存在');
					return;
				}
				
				// 使用HttpUtils下载文件，设置responseType为blob
				this.HttpUtils.get(`/api/file-info/download/${doc.file_id}`, {}, {
					responseType: 'blob'
				}).then(response => {
					// 创建blob URL
					const blob = new Blob([response.data]);
					const blobUrl = window.URL.createObjectURL(blob);
					
					// 创建下载链接
					const link = document.createElement('a');
					link.href = blobUrl;
					link.download = doc.original_file_name || 'download';
					link.style.display = 'none';
					
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					
					// 释放blob URL
					window.URL.revokeObjectURL(blobUrl);
					
					this.$message.success('文件下载成功');
				}).catch(error => {
					console.error('下载失败:', error);
					this.$message.error(error.response?.data?.detail || '文件下载失败');
				});
			}
		}
	}
</script>
<style scoped>
	/* Hero Section */
	.hero-section {
		text-align: center;
		margin-bottom: 60px;
	}

	.hero-badge {
		display: inline-flex;
		align-items: center;
		gap: 8px;
		background: white;
		padding: 8px 20px;
		border-radius: 100px;
		font-size: 14px;
		font-weight: 600;
		color: var(--primary);
		box-shadow: var(--shadow-md);
		margin-bottom: 24px;
	}

	.hero-badge-dot {
		width: 8px;
		height: 8px;
		background: var(--success);
		border-radius: 50%;
		animation: pulse 2s infinite;
	}

	@keyframes pulse {

		0%,
		100% {
			opacity: 1;
		}

		50% {
			opacity: 0.5;
		}
	}

	.hero-title {
		font-size: clamp(32px, 5vw, 48px);
		font-weight: 800;
		line-height: 1.1;
		margin-bottom: 16px;
		background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
	}

	.hero-subtitle {
		font-size: 18px;
		color: var(--text-secondary);
		max-width: 600px;
		margin: 0 auto;
		line-height: 1.6;
	}

	.authorsVal {
		display: flex;
		margin: -10px 0 15px;
		align-items: center;
	}

	.authorsVal .name {
		width: 100px;
	}

	.save-btn {
		margin-left: 10px;
	}

	/* Statistics Cards */
	.stats-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
		gap: 20px;
		margin-bottom: 40px;
	}

	.stat-card {
		background: white;
		border-radius: var(--radius-xl);
		padding: 24px;
		box-shadow: var(--shadow-md);
		border: 1px solid var(--border-light);
		transition: var(--transition-base);
	}

	.stat-card:hover {
		transform: translateY(-4px);
		box-shadow: var(--shadow-xl);
	}

	.stat-icon {
		width: 50px;
		height: 50px;
		border-radius: var(--radius-md);
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		color: white;
		margin-bottom: 16px;
	}

	.stat-number {
		font-size: 32px;
		font-weight: 800;
		color: var(--text-primary);
		margin-bottom: 4px;
	}

	.stat-label {
		font-size: 14px;
		color: var(--text-secondary);
		font-weight: 500;
	}

	/* Management Section */
	.management-section {
		background: white;
		border-radius: var(--radius-xl);
		padding: 32px;
		box-shadow: var(--shadow-md);
		border: 1px solid var(--border-light);
		margin-bottom: 40px;
	}

	.section-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 24px;
		flex-wrap: wrap;
		gap: 16px;
	}

	.section-title {
		font-size: 20px;
		font-weight: 700;
		color: var(--text-primary);
	}

	/* Graph List */
	.graph-list {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.graph-item {
		display: flex;
		align-items: center;
		gap: 20px;
		padding: 24px;
		background: white;
		border-radius: var(--radius-lg);
		border: 1px solid var(--border-light);
		transition: var(--transition-base);
	}

	.graph-item:hover {
		transform: translateY(-2px);
		box-shadow: var(--shadow-lg);
	}

	.graph-info {
		display: flex;
		align-items: center;
		gap: 16px;
		flex: 1;
	}

	.graph-icon {
		width: 60px;
		height: 60px;
		border-radius: var(--radius-md);
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		font-size: 28px;
		background: var(--primary);
	}

	.candidates {
		margin-left: 10px;
	}

	.graph-details h3 {
		font-size: 18px;
		font-weight: 700;
		color: var(--text-primary);
		margin-bottom: 8px;
	}

	.graph-desc {
		font-size: 14px;
		color: var(--text-secondary);
		margin-bottom: 8px;
	}

	.graph-meta {
		display: flex;
		gap: 16px;
		font-size: 12px;
		color: var(--text-tertiary);
	}

	.graph-actions {
		display: flex;
		gap: 8px;
	}

	/* Button Styles */
	.btn {
		padding: 8px 16px;
		border: none;
		border-radius: var(--radius-md);
		font-size: 12px;
		font-weight: 600;
		cursor: pointer;
		transition: var(--transition-base);
	}

	.btn-primary {
		background: var(--primary);
		color: white;
	}

	.btn-primary:hover {
		background: var(--primary-dark);
	}

	.btn-secondary {
		background: var(--bg-gray-100);
		color: var(--text-primary);
		border: 1px solid var(--border-medium);
	}

	.btn-secondary:hover {
		background: var(--bg-gray-200);
	}

	.btn-secondary:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	.btn-danger {
		background: var(--danger);
		color: var(--bg-white);
		border: 1px solid var(--border-medium);
	}

	.btn-sm {
		padding: 4px 12px;
		font-size: 12px;
	}

	/* Modal Styles */
	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1000;
		opacity: 0;
		visibility: hidden;
		transition: var(--transition-base);
	}

	.modal-overlay.show {
		opacity: 1;
		visibility: visible;
	}

	.modal {
		background: white;
		border-radius: var(--radius-xl);
		box-shadow: var(--shadow-xl);
		width: 90%;
		max-width: 700px;
		max-height: 90vh;
		overflow-y: auto;
		transform: translateY(20px);
		transition: var(--transition-base);
	}

	.modal-overlay.show .modal {
		transform: translateY(0);
	}

	.modal-header {
		padding: 24px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid var(--border-light);
	}

	.modal-title {
		font-size: 20px;
		font-weight: 700;
		color: var(--text-primary);
	}

	.modal-close {
		background: none;
		border: none;
		font-size: 24px;
		color: var(--text-tertiary);
		cursor: pointer;
		padding: 4px;
	}

	.modal-body {
		padding: 24px;
	}

	.modal-body .form-group {
		margin-bottom: 20px;
	}

	.modal-body .form-label {
		display: block;
		font-size: 14px;
		font-weight: 600;
		margin-bottom: 6px;
		color: #111827;
	}

	.modal-body .form-input,
	.modal-body .form-select,
	.modal-body .form-textarea {
		width: 100%;
		padding: 12px 16px;
		border: 2px solid #E5E7EB;
		border-radius: 12px;
		font-size: 14px;
		font-family: inherit;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		background: white;
	}

	.modal-footer {
		padding: 24px;
		border-top: 1px solid var(--border-light);
		display: flex;
		gap: 12px;
		justify-content: flex-end;
	}

	/* Manager Assignment */
	.manager-assignment h3 {
		font-size: 16px;
		font-weight: 600;
		color: var(--text-primary);
		margin-bottom: 12px;
	}

	.current-managers {
		margin-bottom: 24px;
	}

	.current-manager {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 12px;
		background: var(--bg-gray-50);
		border-radius: var(--radius-md);
		margin-bottom: 8px;
	}

	.current-manager .manager-avatar {
		width: 40px;
		height: 40px;
		background: var(--primary);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		font-size: 16px;
		font-weight: 700;
	}

	.current-manager .manager-info {
		flex: 1;
	}

	.current-manager .manager-name {
		font-size: 14px;
		font-weight: 600;
		color: var(--text-primary);
		margin-bottom: 2px;
	}

	.current-manager .manager-nodes {
		font-size: 12px;
		color: var(--text-secondary);
	}

	.manager-candidates {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.candidate-item {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 12px;
		border: 2px solid var(--border-light);
		border-radius: var(--radius-md);
		cursor: pointer;
		transition: var(--transition-base);
	}

	.candidate-item:hover {
		border-color: var(--primary-light);
		background: rgba(46, 92, 230, 0.02);
	}

	.candidate-checkbox {
		width: 18px;
		height: 18px;
	}

	.candidate-info {
		display: flex;
		align-items: center;
		gap: 12px;
		flex: 1;
	}

	.candidate-avatar {
		width: 40px;
		height: 40px;
		background: var(--primary);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		font-size: 16px;
		font-weight: 700;
	}

	.candidate-details {
		flex: 1;
	}

	.candidate-name {
		font-size: 14px;
		font-weight: 600;
		color: var(--text-primary);
		margin-bottom: 2px;
	}

	.candidate-role {
		font-size: 12px;
		color: var(--text-secondary);
	}

	/* Responsive */
	@media (max-width: 768px) {
		.main-container {
			padding: 20px 10px;
		}

		.header-container {
			flex-direction: column;
			align-items: stretch;
		}

		.header-nav {
			justify-content: center;
		}

		.hero-title {
			font-size: 28px;
		}

		.stats-grid {
			grid-template-columns: 1fr;
		}

		.section-header {
			flex-direction: column;
			align-items: stretch;
		}

		.graph-item {
			flex-direction: column;
			text-align: center;
		}

		.graph-actions {
			justify-content: center;
			margin-top: 16px;
		}
	}

	/* 文档列表样式 */
	.document-list {
		max-height: 500px;
		overflow-y: auto;
	}

	.document-item {
		display: flex;
		align-items: center;
		gap: 16px;
		padding: 16px;
		border: 1px solid #E5E7EB;
		border-radius: 8px;
		margin-bottom: 12px;
		transition: all 0.3s ease;
	}

	.document-item:hover {
		background: #F9FAFB;
		border-color: #2E5CE6;
	}

	.doc-icon {
		font-size: 32px;
		width: 48px;
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #F0F9FF;
		border-radius: 8px;
	}

	.doc-info {
		flex: 1;
	}

	.doc-name {
		font-size: 16px;
		font-weight: 600;
		color: #111827;
		margin-bottom: 8px;
	}

	.doc-meta {
		display: flex;
		gap: 16px;
		font-size: 12px;
		color: #6B7280;
		margin-bottom: 4px;
	}

	.doc-description {
		font-size: 14px;
		color: #6B7280;
		margin-top: 8px;
		line-height: 1.5;
	}

	.doc-actions {
		display: flex;
		gap: 8px;
	}

	.empty-documents {
		text-align: center;
		padding: 60px 20px;
		color: #6B7280;
	}

	.empty-documents p {
		margin: 0;
		font-size: 16px;
	}
</style>